// Fetches a fresh App Bridge session token. Short-lived (60s); the api
// client calls this once per request, never caches the token in storage
// (PHI hygiene; no localStorage / sessionStorage anywhere in the SPA).
//
// When the SPA is loaded outside Shopify Admin (local dev, direct
// browser hit), window.shopify is undefined; the hook returns null and
// the api client surfaces an "Open from your Shopify Admin" error.

import { useCallback } from 'react';

declare global {
  interface Window {
    shopify?: {
      idToken: () => Promise<string>;
    };
  }
}

export function useSessionToken(): () => Promise<string | null> {
  return useCallback(async (): Promise<string | null> => {
    if (typeof window === 'undefined' || !window.shopify) {
      return null;
    }
    try {
      return await window.shopify.idToken();
    } catch {
      return null;
    }
  }, []);
}
